module.exports = __webpack_public_path__ + "img/daizy_new_forest.9fec0108.jpg";